import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconTick({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd' strokeLinecap='round'>
                <g stroke={color} strokeWidth='2'>
                    <g transform='translate(3 6)'>
                        <path d='M0,6 L6,12' />
                        <path d='M6,12 L18,0' />
                    </g>
                </g>
            </g>
        </svg>
    );
}
